import { render, staticRenderFns } from "./DetailSlider.vue?vue&type=template&id=802c1538&"
import script from "./DetailSlider.vue?vue&type=script&lang=js&"
export * from "./DetailSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports